import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useDeleteAccount = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [deleteAccountLoading, setDeleteAccountLoading] = useState(false);

  const deleteAccountRequest = ({ Guid, onSuccess }) => {
    setDeleteAccountLoading(true);
    axiosClient
      .post(`SettingAccount/Account/Delete?GUID=${Guid}`)
      .then(res => {
        if (res.status === 200) {
          enqueueSnackbar(`حذف با موفقیت انجام شد`, { variant: 'success' });
          onSuccess?.();
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => {
        console.log(err);
        enqueueSnackbar(err?.message, { variant: 'error' });
      })
      .finally(() => setDeleteAccountLoading(false));
  };
  return { deleteAccountRequest, deleteAccountLoading };
};

export default useDeleteAccount;
